import { useEffect } from "react";

export const useBlockBackNavigation = () => {
    useEffect(() => {
        window.history.pushState(null, "", window.location.href);

        const onPopState = () => {
            window.history.pushState(null, "", window.location.href);
        };

        const onKeyDown = (e: KeyboardEvent) => {
            if (e.altKey && e.key === "ArrowLeft") {
                e.preventDefault();
            }
        };

        window.addEventListener("popstate", onPopState);
        window.addEventListener("keydown", onKeyDown);

        return () => {
            window.removeEventListener("popstate", onPopState);
            window.removeEventListener("keydown", onKeyDown);
        };
    }, []);
};

export default useBlockBackNavigation;
